import { useEffect, useState } from 'react';

import { areServicesHealthy } from 'utils';

type Props = {
	isOccasion: boolean;
	isFlex: boolean;
	currentStepNumber: number;
};

export const useHealthStatus = ({ isOccasion, isFlex, currentStepNumber }: Props) => {
	const [isAppHealthy, setIsAppHealthy] = useState(true);
	const [hasAppHealthBeenChecked, setHasAppHealthBeenChecked] = useState(false);
	const isAtThankYouStep = currentStepNumber === 4;

	useEffect(() => {
		const setHealthStatusForServices = async () => {
			if (!isAtThankYouStep) {
				const areServicesHealthyResult = await areServicesHealthy(isOccasion, isFlex);
				setIsAppHealthy(areServicesHealthyResult);
				setHasAppHealthBeenChecked(true);
			}
		};

		setHealthStatusForServices();
	}, [currentStepNumber, isAtThankYouStep, isOccasion, isFlex]);

	return { isAppHealthy, hasAppHealthBeenChecked, setIsAppHealthy };
};
